import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, Eyebrow } from "../components/Section";
import { PARTNER_TYPES } from "../lib/content";

export default function Partner() {
  return (
    <div data-testid="partner-page">
      <PageHero
        eyebrow="Partner With Us"
        num="01"
        title={<>Specialist depth — <span className="italic text-[var(--bjc-gold)]">at the side</span> of your firm.</>}
        intro="BJC collaborates with professional firms and institutions to deliver specialist AML and financial crime advisory, complementing existing capabilities with a focused, regulator-aware practice."
      />

      <section className="bjc-section border-b border-[var(--bjc-border)]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
            <div className="md:col-span-4">
              <Eyebrow num="02">Partner Types</Eyebrow>
            </div>
            <div className="md:col-span-8">
              <h2 className="font-serif-display text-3xl md:text-5xl leading-[1.05] text-[var(--bjc-text)]">
                Who we collaborate with.
              </h2>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-[var(--bjc-border)] border border-[var(--bjc-border)]">
            {PARTNER_TYPES.map((p, i) => (
              <div
                key={p.title}
                data-testid={`partner-type-${i}`}
                className="bjc-card p-10 md:p-12 min-h-[220px]"
              >
                <span className="bjc-numeral">— 0{i + 1}</span>
                <h3 className="mt-4 font-serif-display text-2xl md:text-3xl text-[var(--bjc-text)]">{p.title}</h3>
                <p className="mt-4 text-[var(--bjc-text-muted)] leading-relaxed">{p.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bjc-section">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-12 items-start">
          <div className="md:col-span-5">
            <Eyebrow num="03">Value</Eyebrow>
            <h2 className="mt-6 font-serif-display text-3xl md:text-5xl leading-[1.04] text-[var(--bjc-text)]">
              Specialist expertise. Independent judgement.
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 space-y-6">
            <p className="text-lg text-[var(--bjc-text)] leading-relaxed">
              We bring specialist expertise, independent judgement, and structured advisory to
              complement partner capabilities — under engagement structures that protect both
              the partnership and the client outcome.
            </p>
            <p className="text-base text-[var(--bjc-text-muted)] leading-relaxed">
              Engagements are typically scoped collaboratively, with a clear delivery owner and a
              senior practitioner present throughout.
            </p>
            <div className="pt-4">
              <Link to="/contact" data-testid="partner-cta" className="bjc-btn-primary">
                Explore Collaboration <ArrowRight size={14} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
